import * as React from 'react'
import { Row, Col, InputGroup, Input } from 'reactstrap'
import $ from 'jquery'
import { accentUtils, showDialog, t } from '../services/HelperService';
import { RTLGridCtrl } from './grids/RTLGridCtrl';
import { AccentButton } from './AccentButton';
import { AccentDialog } from '../dialogs/AccentDialog';
import { queryNoTracking } from '../services/DataService';


const query_GenericEntitySelect = queryNoTracking("GenericEntitySelect", 0);
const genericEntitySelectGridID = "2D1F7A4B-9C8E-4A6F-B3D2-6E0F5A9C1B74";
const genericEntitySelectGrid = [
    { fieldName: "ID", caption: "ID" },
    { fieldName: "Prompt", caption: "Prompt" }
];



export const RTLSearchSelectCtrl = React.memo(React.forwardRef((props, ref) => {

    const [searchPhrase, setSearchPhrase] = React.useState(null);
    const [forceGridRefresh, setForceGridRefresh] = React.useState(1);
    const grid = React.useRef();

    const closeDlg = React.useCallback((e) => {

        const selection = accentUtils.isNull(grid.current) ? [] : grid.current.getSelected();


        props.onClose({
            canceled: false,
            selection: selection
        });
    }, [props]);


    // noLinks: a picker is for choosing a row, so entity link columns (the job reference, the
    // contact) render as plain text instead of navigating away from the screen the picker
    // was opened from.
    const noLinks = props.noLinks ?? false;
    const processColumn = React.useCallback(col => {
        if (noLinks && col?.isLink) {
            return { ...col, isLink: false, linkField: undefined, linkEntity: undefined };
        }
        return col;
    }, [noLinks]);

    const runSearch = React.useCallback(r => {
        var value = $("#selectSearch").val();


        setForceGridRefresh(forceGridRefresh => forceGridRefresh + 1);

        setSearchPhrase(value);

        if (r && r.promise) {
            r.promise();
        }


    }, [setSearchPhrase, forceGridRefresh, setForceGridRefresh]);

    const keyPress = React.useCallback(e => {



        if (e.charCode === 13) {

            runSearch();

        }
    }, [runSearch]);


    var g = null;
    var result = null;



    if (!accentUtils.isEmpty(searchPhrase) || props.runQueryOnShow) {


        if (g === null) {
            g = <RTLGridCtrl
                key={forceGridRefresh}
                gridID={props.gridID}
                methods={grid}
                className="acc-act-main-grid"
                height="400"
                query={() => props.query(searchPhrase)}
                columns={props.columns}
                processColumn={processColumn}
                clearSelection
                showCheckbox={!(props.singleSelection ?? false)} />;
        }


        result = (
            <Row>
                <Col md={12}>
                    {g}
                </Col>
            </Row>
        );


    }

    const allowClose = false;

    return (
        <AccentDialog
            className="rtlSearchSelectDlg"
            onClose={props.onClose}
            headerContent={t(props.title)}
            actionsContent={[                
                <AccentButton key="2" tagName="calCloseBtn" disabled={allowClose} onClick={closeDlg}>{t(props.closeTitle)}</AccentButton>
            ]}
        >
            {!props.hideSearch && <Row>
                <Col md={12}>
                    <InputGroup>
                        <Input onKeyPress={keyPress} type="text" name="search" data-tagname="selectSearch" id="selectSearch" placeholder={t(props.searchPlaceholder)} />
                        <AccentButton tagName="newLeadSeachBtn" onClick={runSearch}>{t("application_strings.application.buttons.search")}</AccentButton>
                    </InputGroup>
                </Col>
            </Row>}
            {result}
        </AccentDialog>);


}));




export const SelectEntityButton = ({ entity, query, grid, children, onSelected, singleSelection, disabled, onBeforeClick, noLinks }) => {

    const onSelect = async e => {
        // Check onBeforeClick if provided - only proceed if it returns true
        if (onBeforeClick) {
            const shouldProceed = await onBeforeClick();
            if (!shouldProceed) {
                // User cancelled or chose not to proceed
                if (e.promise)
                    e.promise();
                return;
            }
        }

        const res = await showDialog(<RTLSearchSelectCtrl
            title={`Select ${entity}`}
            closeTitle="SELECT"
            searchPlaceholder="search"
            gridID={`SelectEntityButton_${entity}_AB970190-3E40-4E4A-93F9-A2223A7752D1`}
            query={query}
            columns={grid}
            singleSelection={singleSelection}
            noLinks={noLinks}
        />);

        if (!res.canceled && res.selection && res.selection.length > 0) {
            onSelected(res.selection);
        }

        if (e.promise)
            e.promise();
    }

    return <AccentButton disabled={disabled} onClick={onSelect}>{children}</AccentButton>
}

export const GenericEntitySelectButton = ({
    entity,
    children,
    onSelected,
    singleSelection,
    disabled,
    onBeforeClick,
    style,
    className,
    size,
    bsStyle,
    outline,
    title
}) => {

    const onSelect = async e => {
        if (onBeforeClick) {
            const shouldProceed = await onBeforeClick();
            if (!shouldProceed) {
                if (e.promise)
                    e.promise();
                return;
            }
        }

        const res = await showDialog(<RTLSearchSelectCtrl
            title={`Select ${entity}`}
            closeTitle="SELECT"
            searchPlaceholder="search"
            gridID={genericEntitySelectGridID}
            query={searchPhrase => query_GenericEntitySelect.getAllAsQueryable({ entityType: entity, searchPhrase })}
            columns={genericEntitySelectGrid}
            singleSelection={singleSelection}
            runQueryOnShow
        />);

        if (!res.canceled && res.selection && res.selection.length > 0) {
            onSelected(res.selection);
        }

        if (e.promise)
            e.promise();
    }

    return (
        <AccentButton
            disabled={disabled}
            onClick={onSelect}
            style={style}
            className={className}
            size={size}
            bsStyle={bsStyle}
            outline={outline}
            title={title}
        >
            {children}
        </AccentButton>
    );
}
